<div class="head" (click)="toggleIsOpen()">
  <span>{{ title | translate }}</span>
</div>

<div class="content" [style.height]="isOpen ? contentHeight + 'px' : 0">
  @if (isOpen) {
    <ng-container *ngTemplateOutlet="content"></ng-container>
  }
</div>

<!--absolute content only for measuring height-->
<!--later removed-->
<div class="absolute-content" #absoluteContent>
  <div class="content">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</div>
